<template>
  <div class="font-sans antialiased text-gray-900 leading-normal tracking-wider content">
    <div class="min-h-screen flex flex-col font-sans">
      <div class="flex-grow">
        <div class="max-w-4xl h-auto flex items-center justify-center h-auto flex-wrap mx-auto my-28 lg:my-0">

          <!--Main Col-->

          <div class="w-full lg:w-3/5 rounded-lg lg:rounded-lg shadow-2xl bg-white mx-6 lg:mx-0 my-16">

            <div class="p-4 md:p-12 text-center">
              <div class="flex justify-center">
                <a class="no-underline hover:no-underline" href="https://www.greengeeks.com/">
                  <img alt="GreenGeeks logo" src="/static/img/amui/logo_black.png" class="mb-6">
                </a>
              </div>
              <br/>
              <div v-if="loading" class="mt-2 mb-6"><preloader></preloader></div>
              <p v-else-if="error" class="mt-2 mb-6" >{{ error }}</p>
              <template v-else>
                <!-- Verified title -->
                <template v-if="verified">
                  <h1 class="text-3xl font-bold pt-8 lg:pt-0">
                    <svg class="h-10 w-10 fill-current inline-block ggs-green pb-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44">
                      <path d="m22,0c-12.2,0-22,9.8-22,22s9.8,22 22,22 22-9.8 22-22-9.8-22-22-22zm12.7,15.1l0,0-16,16.6c-0.2,0.2-0.4,0.3-0.7,0.3-0.3,0-0.6-0.1-0.7-0.3l-7.8-8.4-.2-.2c-0.2-0.2-0.3-0.5-0.3-0.7s0.1-0.5 0.3-0.7l1.4-1.4c0.4-0.4 1-0.4 1.4,0l.1,.1 5.5,5.9c0.2,0.2 0.5,0.2 0.7,0l13.4-13.9h0.1c0.4-0.4 1-0.4 1.4,0l1.4,1.4c0.4,0.3 0.4,0.9 0,1.3z"/>
                    </svg>
                    Verified Green
                  </h1>
                  <div class="mx-auto w-4/5 pt-1 border-b-2 border-green-600 opacity-75"></div>
                </template>
                <!-- Not Verified title -->
                <template v-else>
                  <h1 class="text-3xl font-bold pt-8 lg:pt-0">
                    <svg class="h-10 w-10 fill-current inline-block text-red-500 pb-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 51.976 51.976">
                      <path d="M44.373,7.603c-10.137-10.137-26.632-10.138-36.77,0c-10.138,10.138-10.137,26.632,0,36.77s26.632,10.138,36.77,0
      C54.51,34.235,54.51,17.74,44.373,7.603z M36.241,36.241c-0.781,0.781-2.047,0.781-2.828,0l-7.425-7.425l-7.778,7.778
      c-0.781,0.781-2.047,0.781-2.828,0c-0.781-0.781-0.781-2.047,0-2.828l7.778-7.778l-7.425-7.425c-0.781-0.781-0.781-2.048,0-2.828
      c0.781-0.781,2.047-0.781,2.828,0l7.425,7.425l7.071-7.071c0.781-0.781,2.047-0.781,2.828,0c0.781,0.781,0.781,2.047,0,2.828
      l-7.071,7.071l7.425,7.425C37.022,34.194,37.022,35.46,36.241,36.241z"/>
                    </svg>
                    Not Green
                  </h1>
                  <div class="mx-auto w-4/5 pt-1 border-b-2 border-red-500 opacity-75"></div>
                </template>

                <p class="pt-2 font-bold lg:text-sm flex items-center justify-center">
                  <svg class="h-4 fill-current text-teal-700 pr-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                    <path d="M10 20a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm7.75-8a8.01 8.01 0 0 0 0-4h-3.82a28.81 28.81 0 0 1 0 4h3.82zm-.82 2h-3.22a14.44 14.44 0 0 1-.95 3.51A8.03 8.03 0 0 0 16.93 14zm-8.85-2h3.84a24.61 24.61 0 0 0 0-4H8.08a24.61 24.61 0 0 0 0 4zm.25 2c.41 2.4 1.13 4 1.67 4s1.26-1.6 1.67-4H8.33zm-6.08-2h3.82a28.81 28.81 0 0 1 0-4H2.25a8.01 8.01 0 0 0 0 4zm.82 2a8.03 8.03 0 0 0 4.17 3.51c-.42-.96-.74-2.16-.95-3.51H3.07zm13.86-8a8.03 8.03 0 0 0-4.17-3.51c.42.96.74 2.16.95 3.51h3.22zm-8.6 0h3.34c-.41-2.4-1.13-4-1.67-4S8.74 3.6 8.33 6zM3.07 6h3.22c.2-1.35.53-2.55.95-3.51A8.03 8.03 0 0 0 3.07 6z"/>
                  </svg>
                  <a class="text-lg no-underline hover:no-underline" :href="'http://' + verification.domain">{{ verification.domain }}</a>
                </p>
                <p class="pt-2 lg:text-sm flex items-center justify-center">
                  <svg class="h-4 fill-current text-teal-700 pr-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 97.16 97.16">
                    <path d="M48.58,0C21.793,0,0,21.793,0,48.58s21.793,48.58,48.58,48.58s48.58-21.793,48.58-48.58S75.367,0,48.58,0z M48.58,86.823
        c-21.087,0-38.244-17.155-38.244-38.243S27.493,10.337,48.58,10.337S86.824,27.492,86.824,48.58S69.667,86.823,48.58,86.823z"/>
                    <path d="M73.898,47.08H52.066V20.83c0-2.209-1.791-4-4-4c-2.209,0-4,1.791-4,4v30.25c0,2.209,1.791,4,4,4h25.832
        c2.209,0,4-1.791,4-4S76.107,47.08,73.898,47.08z"/>
                  </svg>
                  <!-- current time -->
                  <span class="text-lg">{{ verification.time }}</span>
                </p>
                <p class="pt-4 font-bold text-gray-700 flex items-center justify-center mb-6" v-show="!verified">
                  This website is not verified using Green Hosting
                </p>
                <p class="pt-4 font-bold text-gray-700 flex items-center justify-center mb-6" v-show="verified">
                  This website is verified using Green Hosting
                </p>
                <p v-if="verified" class="text-sm">
                  The Internet is a huge polluter of the environment. This website's carbon footprint is not offset, but
                  reduced by using 300% Green Powered Web Hosting provided by
                  <a class="ggs-green" style="font-weight:bold;" href="https://www.greengeeks.com" target="new">GreenGeeks</a>.
                </p>

                <p v-else class="text-sm">
                  The Internet is a huge polluter of the environment. This website's carbon footprint could be
                  reduced by using 300% Green Powered Web Hosting provided by
                  <a class="ggs-green" style="font-weight:bold;" href="https://www.greengeeks.com" target="new">GreenGeeks</a>.
                </p>

                <div class="pt-6">
                  <a href="https://www.greengeeks.com/going-green">
                    <button class="bg-green-600 hover:bg-teal-900 text-white font-bold py-2 px-4 rounded-full">Learn More</button>
                  </a>
                </div>
              </template>
            </div>

          </div>

        </div>
      </div>
      <div>
        <!--Footer-->
        <footer class="bg-white">
          <div class="container max-w-4xl mx-auto my-28 lg:my-0 mx-auto">
            <div class="flex md:flex-row flex-col justify-around pt-6 text-center md:text-left">
              <div>
                <p class="uppercase text-gray-500 md:mb-6">Get Help</p>
                <ul class="list-reset mb-6">
                  <li class="mt-2 inline-block mr-2 md:block md:mr-0">
                    <a href="https://www.greengeeks.com/kb"
                       class="no-underline hover:underline text-gray-800 hover:text-green-600">Knowledge Base</a>
                  </li>
                  <li class="mt-2 inline-block mr-2 md:block md:mr-0">
                    <a href="https://www.greengeeks.com/tutorials"
                       class="no-underline hover:underline text-gray-800 hover:text-green-600">Website Tutorials</a>
                  </li>
                  <li class="mt-2 inline-block mr-2 md:block md:mr-0">
                    <a href="https://www.greengeeks.com/support/"
                       class="no-underline hover:underline text-gray-800 hover:text-green-600">Support</a>
                  </li>
                </ul>
              </div>
              <div>
                <p class="uppercase text-gray-500 md:mb-6">Services</p>
                <ul class="list-reset mb-6">
                  <li class="mt-2 inline-block mr-2 md:block md:mr-0">
                    <a href="https://www.greengeeks.com/shared-hosting"
                       class="no-underline hover:underline text-gray-800 hover:text-green-600">Shared Hosting</a>
                  </li>
                  <li class="mt-2 inline-block mr-2 md:block md:mr-0">
                    <a href="https://www.greengeeks.com/reseller-hosting"
                       class="no-underline hover:underline text-gray-800 hover:text-green-600">Reseller Hosting</a>
                  </li>
                  <li class="mt-2 inline-block mr-2 md:block md:mr-0">
                    <a href="https://www.greengeeks.com/vps-hosting"
                       class="no-underline hover:underline text-gray-800 hover:text-green-600">VPS Hosting</a>
                  </li>
                  <li class="mt-2 inline-block mr-2 md:block md:mr-0">
                    <a href="https://www.greengeeks.com/dedicated-servers"
                       class="no-underline hover:underline text-gray-800 hover:text-green-600">Dedicated Servers</a>
                  </li>
                  <li class="mt-2 inline-block mr-2 md:block md:mr-0">
                    <a href="https://www.greengeeks.com/website-builder"
                       class="no-underline hover:underline text-gray-800 hover:text-green-600">Website Builder</a>
                  </li>
                </ul>
              </div>
              <div>
                <p class="uppercase text-gray-500 md:mb-6">App Hosting</p>
                <ul class="list-reset mb-6">
                  <li class="mt-2 inline-block mr-2 md:block md:mr-0">
                    <a href="https://www.greengeeks.com/wordpress-hosting"
                       class="no-underline hover:underline text-gray-800 hover:text-green-600">
                      WordPress Hosting
                    </a>
                  </li>
                  <li class="mt-2 inline-block mr-2 md:block md:mr-0">
                    <a href="https://www.greengeeks.com/drupal-hosting"
                       class="no-underline hover:underline text-gray-800 hover:text-green-600">
                      Drupal Hosting
                    </a>
                  </li>
                  <li class="mt-2 inline-block mr-2 md:block md:mr-0">
                    <a href="https://www.greengeeks.com/joomla-hosting"
                       class="no-underline hover:underline text-gray-800 hover:text-green-600">
                      Joomla Hosting
                    </a>
                  </li>
                  <li class="mt-2 inline-block mr-2 md:block md:mr-0">
                    <a href="https://www.greengeeks.com/cpanel-hosting"
                       class="no-underline hover:underline text-gray-800 hover:text-green-600">
                      cPanel Hosting
                    </a>
                  </li>
                  <li class="mt-2 inline-block mr-2 md:block md:mr-0">
                    <a href="https://www.greengeeks.com/cms-hosting"
                       class="no-underline hover:underline text-gray-800 hover:text-green-600">
                      CMS Hosting
                    </a>
                  </li>
                  <li class="mt-2 inline-block mr-2 md:block md:mr-0">
                    <a href="https://www.greengeeks.com/magento-hosting"
                       class="no-underline hover:underline text-gray-800 hover:text-green-600">
                      Magento Hosting
                    </a>
                  </li>
                </ul>
              </div>
              <div>
                <p class="uppercase text-gray-500 md:mb-6">Why GreenGeeks</p>
                <ul class="list-reset mb-6">
                  <li class="mt-2 inline-block mr-2 md:block md:mr-0">
                    <a href="https://www.greengeeks.com/platform"
                       class="no-underline hover:underline text-gray-800 hover:text-green-600">
                      Our Hosting Platform
                    </a>
                  </li>
                  <li class="mt-2 inline-block mr-2 md:block md:mr-0">
                    <a href="https://www.greengeeks.com/going-green"
                       class="no-underline hover:underline text-gray-800 hover:text-green-600">
                      Why Green Hosting
                    </a>
                  </li>
                  <li class="mt-2 inline-block mr-2 md:block md:mr-0">
                    <a href="https://www.greengeeks.com/about/greengeeks-reviews.php"
                       class="no-underline hover:underline text-gray-800 hover:text-green-600">
                      GreenGeeks Reviews
                    </a>
                  </li>
                  <li class="mt-2 inline-block mr-2 md:block md:mr-0">
                    <a href="https://www.greengeeks.com/about/"
                       class="no-underline hover:underline text-gray-800 hover:text-green-600">
                      About The Company
                    </a>
                  </li>
                  <li class="mt-2 inline-block mr-2 md:block md:mr-0">
                    <a href="https://www.greengeeks.com/affiliates"
                       class="no-underline hover:underline text-gray-800 hover:text-green-600">
                      Affiliate Program
                    </a>
                  </li>
                  <li class="mt-2 inline-block mr-2 md:block md:mr-0">
                    <a href="https://www.greengeeks.com/about/service-guarantee.php"
                       class="no-underline hover:underline text-gray-800 hover:text-green-600">
                      Service Guarantees
                    </a>
                  </li>
                  <li class="mt-2 inline-block mr-2 md:block md:mr-0">
                    <a href="https://www.greengeeks.com/about/"
                       class="no-underline hover:underline text-gray-800 hover:text-green-600">
                      About the company
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import format from 'date-fns/format'
import { mapActions } from 'vuex'
import amapi from '@/api/amapi'
import Preloader from '@/components/Common/Preloader'

export default {
  name: 'Seal',
  components: { Preloader },
  data () {
    return {
      loading: true,
      verification: {
        time: '',
        domain: '',
        green: false,
      },
      error: '',
    }
  },
  computed: {
    verified () {
      return this.verification.green
    }
  },
  methods: {
    ...mapActions(['initializeSession']),
    startSession (name) {
      this.initializeSession()
      this.$router.push({ name })
    }
  },
  async mounted () {
    await this.$nextTick()
    const referer = document.referrer || this.$route.query?.ref // TODO: remove $route.query?.ref after testing
    let response
    try {
      response = await amapi.makecall('ggseal_verify', { referer })
      this.loading = false
      if (response.result == 0) {
        const error = response.resultmsg || 'Oops! Something went wrong.'
        throw error
      }
    } catch (err) {
      this.error = err
      console.warn(err)
      return
    }
    this.verification.domain = response.domain
    this.verification.green = response.green
    this.verification.time = format(new Date(), 'yyyy-MM-dd h:mm a')
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/scss/seal";
</style>
